import { defineComponent as L, ref as f, computed as S, watch as N, onMounted as x, onBeforeUnmount as H, openBlock as c, createBlock as k, Transition as $, withCtx as U, createElementVNode as Z, normalizeClass as V, normalizeStyle as y, unref as _, createCommentVNode as b, renderSlot as A, createElementBlock as v, toDisplayString as D, createVNode as T, render as P } from "vue";
import { useZIndex as R } from "element-plus";
import w from "@patsnap-biz/icon";
import "@patsnap-ui/icon/assets/solid/CloseMedium.svg";
import "@patsnap-ui/icon/assets/solid/SmilesHappy.svg";
import "@patsnap-ui/icon/assets/solid/info.svg";
import "@patsnap-ui/icon/assets/solid/warning.svg";
import "@patsnap-ui/icon/assets/solid/SmilesSad.svg";
const W = {
  key: 0,
  class: "patsnap-biz-toast__content"
}, j = ["innerHTML"], q = {
  key: 1,
  class: "patsnap-biz-toast__close-btn"
}, F = /* @__PURE__ */ L({
  __name: "Toast",
  props: {
    message: {},
    duration: { default: 3e3 },
    type: { default: "info" },
    icon: {},
    onClose: {},
    showClose: { type: Boolean, default: !1 },
    size: { default: "medium" },
    dangerouslyUseHTMLString: { type: Boolean, default: !1 }
  },
  setup(e, { expose: n }) {
    const t = e, i = {
      success: "SolidSmilesHappy",
      info: "SolidInfo",
      warning: "SolidWarning",
      error: "SolidSmilesSad"
    }, r = f(null), u = f(!1), p = f(3e3), { nextZIndex: M } = R(p);
    let g;
    const m = S(() => t.icon === null ? null : t.icon || i[t.type]), h = S(() => t.size === "medium" ? "24px" : "16px");
    function B() {
      r.value && r.value.parentNode && r.value.parentNode.removeChild(r.value);
    }
    N(() => u.value, (o) => {
      o && B();
    });
    function d() {
      u.value = !0, typeof t.onClose == "function" && t.onClose();
    }
    function I() {
      clearTimeout(g);
    }
    function z() {
      t.duration > 0 && (g = setTimeout(() => {
        u.value || d();
      }, t.duration));
    }
    function C(o) {
      o.key === "Escape" && (u.value || d());
    }
    return x(() => {
      z(), p.value = M(), document.addEventListener("keydown", C);
    }), H(() => {
      document.removeEventListener("keydown", C);
    }), n({
      close: d
    }), (o, J) => (c(), k($, { name: "pt-message-fade" }, {
      default: U(() => [
        Z("div", {
          ref_key: "toastEl",
          ref: r,
          class: V([
            "patsnap-biz-toast",
            `patsnap-biz-toast--${o.type}`,
            `patsnap-biz-toast--${o.size}`,
            {
              "patsnap-biz-toast--closable": o.showClose,
              "patsnap-biz-toast--without-icon": !m.value
            }
          ]),
          style: y({ zIndex: p.value }),
          role: "alert",
          onMouseenter: I,
          onMouseleave: z
        }, [
          m.value ? (c(), k(_(w), {
            key: 0,
            icon: m.value,
            style: y({ fontSize: h.value, marginRight: "8px" })
          }, null, 8, ["icon", "style"])) : b("", !0),
          A(o.$slots, "default", {}, () => [
            o.dangerouslyUseHTMLString ? (c(), v("p", {
              key: 1,
              class: "patsnap-biz-toast__content",
              innerHTML: o.message
            }, null, 8, j)) : (c(), v("p", W, D(o.message), 1))
          ]),
          o.showClose ? (c(), v("span", q, [
            T(_(w), {
              icon: "SolidCloseMedium",
              style: y({ fontSize: h.value }),
              onClick: d
            }, null, 8, ["style"])
          ])) : b("", !0)
        ], 38)
      ]),
      _: 3
    }));
  }
});
let a;
const l = [];
let E = 1;
function s(e = {}) {
  const n = document.createElement("div"), t = typeof e == "string" ? null : e.onClose;
  E += 1;
  const i = `toast_${E}`;
  return a = T(F, {
    ...typeof e == "string" ? { message: e } : e,
    onClose() {
      s.close(i, t);
    }
  }), a.id = i, P(a, n), a.vm = a.component, document.body.appendChild(n.firstElementChild), l.push(a), a.vm;
}
["success", "warning", "info", "error"].forEach((e) => {
  s[e] = (n) => s(typeof n == "string" ? {
    message: n,
    type: e
  } : {
    ...n,
    type: e
  });
});
s.close = (e, n) => {
  for (let t = 0, i = l.length; t < i; t += 1)
    if (e === l[t].id) {
      typeof n == "function" && n(l[t]), l.splice(t, 1);
      break;
    }
};
s.closeAll = () => {
  for (let e = l.length - 1; e >= 0; e -= 1)
    l[e].vm.exposed.close();
};
function oe(e) {
  e.toast = s, e.prototype.$toast = s;
}
export {
  s as Toast,
  s as default,
  oe as install
};
